

























































































// decoradores
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { Contrato } from "@/typings/store/plugins/easyFirestore/contratos";
import SVGIcon from "@/components/SVGIcon.vue";
// tipos

// tipos
@Component({
  components: {
    SVGIcon,
  },
})
export default class InfoBanco extends Vue {
  @Prop() readonly contrato!: Contrato;
  @Prop({ type: Boolean }) readonly showTitulo!: boolean;

  get id(): string {
    return this.contrato.id || "N/R";
  }

  get cliente(): {
    codigo: string;
    nombre: string;
    rut: string;
    giro: string;
    telefono: string;
    direccion: string;
    correo: string;
    nombre_comercial: string;
  } {
    return (
      this.contrato?.clienteSnapshot || {
        codigo: "",
        nombre: "",
        rut: "",
        giro: "",
        telefono: "",
        direccion: "",
        correo: "",
        nombre_comercial: "",
      }
    );
  }

  get dia_uf(): number {
    return this.contrato.dia_uf || 0;
  }

  get superficieTotal(): number {
    return this.contrato.superficieTotal || 0;
  }

  get fechaInicio(): string {
    return this.contrato.fechaInicio || "N/R";
  }

  get fechaFin(): string {
    return (
      new Date(this.contrato.fechaFin).toLocaleDateString("es-ES") || "N/R"
    );
  }

  get pdfContrato(): string {
    return this.contrato.pdfContratoUrl || "N/R";
  }

  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
